import React, { useState } from "react"
import "./banner.sass"
import VisibilitySensor from "react-visibility-sensor"
import { $c, defaultIntl, gtag_report_conversion } from "../../utils"
import { animateScroll } from "react-scroll"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { webHref } from "../../utils/constant"
import { languageMap } from "../../utils/constant"
const isBrowser = typeof window !== "undefined"
export default ({ intl = defaultIntl }) => {
  const data = useStaticQuery(graphql`
    query {
      pic: file(relativePath: { eq: "head-pic@2x.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  const isWeixin = () => {
    if(isBrowser){
      const { userAgent: u } = window.navigator
      return {
        weixin: u.includes("MicroMessenger"), //是否微信 
      }
    }
    return {
      weixin: false
    }
  }

  const { weixin } = isWeixin()

  const [visible, setVisible] = useState(false)
  const goDownload = e => {
    e.preventDefault()
    if (weixin) {
      window.location.href = ' https://wechat.fantuan.ca/others/download.html'
      gtag_report_conversion()
    } else {
      window.location.href = 'https://fantuan.go.link/?adj_t=b5m1oee'
      gtag_report_conversion()
    }
  }

  const goWebOrder = e => {
    e.preventDefault()
    if (weixin) {
      window.location.href = 'https://wechat.fantuan.ca/'
      gtag_report_conversion()
    } else {
      window.location.href = `${webHref(languageMap[intl.locale])}`
      gtag_report_conversion()
    }
  }

  return (
    <VisibilitySensor onChange={v => setVisible(v)}>
      <div className="banner">
        <div className="bg-size">
          <Img fluid={data.pic.childImageSharp.fluid} alt="fantuan pic" style={{ height: "100%" }} imgStyle={{ objectFit: "cover" }} />
        </div>
        <div className={$c(`container selected2`)(visible, "fadeIn")}>
          <div className="vertical">
            <div className={$c("slogan slow")(visible, "fadeInUp")}>
              <pre>{intl.formatMessage({ id: "index.banner.title" })}</pre>
            </div>
            <div className={$c("button-links delay-0-5s")(visible, "fadeInUp")}>
              {['zh', 'en', 'fr'].includes(intl.locale) && <a href='#' onClick={goWebOrder} className="btn web">
                {intl.formatMessage({ id: "index.banner.web_btn" })}
                <i className="icon-right" />
              </a>}
              <a href="#" onClick={goDownload} className="btn download">
                {intl.formatMessage({ id: "index.banner.download_btn" })}
                <i className="icon-right" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </VisibilitySensor>
  )
}
